<template>
	<div>
		<span v-if="this.hasLinkAction"
			 @click="doLinkAction"
			 class="accent_color pointer text-dense">
			{{ localizeReceivableState(state) }}
		</span>
		<div v-else>
			{{ localizeReceivableState(state) }}
		</div>
	</div>
</template>

<script>
import {formatAsLocalizedEnum} from "@/common/format";

export default {
	computed: {
		enumDef() {
			return this.params.enumDef;
		},
		state() {
			return this.params.data[this.params.colDef.field];
		},
		customization() {
			return this.params.customization ?? {};
		},
		customizationForState() {
			return this.customization.hasOwnProperty(this.state) ? this.customization[this.state] : {};
		},
		linkAction() {
			// Check if a custom link action exists for the current state
			const hasCustomLinkAction = this.customizationForState.hasOwnProperty("linkAction");
			if (hasCustomLinkAction) {
				return this.customizationForState["linkAction"];
			}

			// Otherwise check default link action
			let defaultLinkAction = this.params.defaultLinkAction;
			if (defaultLinkAction) {
				return defaultLinkAction;
			}

			// No link action -> display the enum without link style
			return null;
		},
		hasLinkAction() {
			return this.linkAction !== null;
		}
	},
	methods: {
		doLinkAction() {
			this.linkAction(this.params.data);
		},
		localizeReceivableState(value) {
			if (this.customizationForState.hasOwnProperty("key")) {
				return this.$t(this.customizationForState.key);
			}

			return formatAsLocalizedEnum(this.enumDef, value);
		}
	}
};
</script>